( function( $ ) {
	'use strict';

	$( function() {
		const $carousel = $( '.js-testimonial-carousel' );
		const dotsContainerSelector = '.js-testimonial-carousel-dots';

		$carousel.owlCarousel( {
			items: 1,
			dots: true,
			dotsContainer: dotsContainerSelector,
			dotsData: true,
			nav: false,
			margin: 20,
			loop: true
		} );

		$( dotsContainerSelector ).find( '.owl-dot' ).on( 'click', function() {
			$carousel.trigger( 'to.owl.carousel', [$( this ).index()] );
		} );

	} );
} )( jQuery );
